/******/ (() => { // webpackBootstrap
/*!*************************************************!*\
  !*** ./src/scripts/collections/powerreviews.js ***!
  \*************************************************/
// Ensure global array exists just like in powerreviews-displays.liquid
window.powerreviews_array = window.powerreviews_array || [];
window.initPowerReviewsCategory = function () {
  var snippetContainers = document.querySelectorAll('.pr-category-snippet');
  if (!snippetContainers || snippetContainers.length === 0) {
    return;
  }
  var apiKey = "39bdf60f-e53a-430c-9098-acdd9f3fedbb";
  var merchantGroupId = "819246110";
  var merchantId = "1555802474";
  var hasNewItems = false;
  snippetContainers.forEach(function (container) {
    var productId = container.getAttribute('data-pr-product-id');
    var snippetId = container.getAttribute('id');
    if (productId && snippetId && !container.hasAttribute('data-pr-initialized')) {
      window.powerreviews_array.push({
        api_key: apiKey,
        locale: "en_CA",
        merchant_group_id: merchantGroupId,
        merchant_id: merchantId,
        page_id: productId,
        components: {
          CategorySnippet: snippetId
        }
      });
      container.setAttribute('data-pr-initialized', 'true');
      hasNewItems = true;
    }
  });
  if (hasNewItems) {
    if (typeof POWERREVIEWS !== 'undefined' && POWERREVIEWS.display) {
      POWERREVIEWS.display.render(window.powerreviews_array);
    } else {
      if (!document.getElementById('pr-ui-script')) {
        var script = document.createElement('script');
        script.id = 'pr-ui-script';
        script.src = '//ui.powerreviews.com/stable/4.0/ui.js';
        script.onload = function () {
          if (typeof POWERREVIEWS !== 'undefined' && POWERREVIEWS.display) {
            POWERREVIEWS.display.render(window.powerreviews_array);
          }
        };
        document.head.appendChild(script);
      }
    }
  }
};

// Listen for the initial DOM load to run the initialization
document.addEventListener('DOMContentLoaded', function () {
  window.initPowerReviewsCategory();

  // Set up a MutationObserver to watch for AJAX loaded products so we don't have to touch theme scripts
  var gridWrapper = document.querySelector('[data-collection-main]') || document.querySelector('[data-search-main]') || document.querySelector('.search-matrix') || document.body;
  if (gridWrapper) {
    var observer = new MutationObserver(function (mutations) {
      var shouldReinit = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Verify if the added nodes contain our target snippet to avoid unnecessary re-runs
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.nodeType === 1 && (node.classList.contains('pr-category-snippet') || node.querySelector('.pr-category-snippet'))) {
              shouldReinit = true;
              break;
            }
          }
        }
      });
      if (shouldReinit) {
        // Re-run initialization to capture newly added products
        setTimeout(window.initPowerReviewsCategory, 50);
      }
    });

    // Observe changes to the collection wrapper or body
    observer.observe(gridWrapper, {
      childList: true,
      subtree: true
    });
  }
});
/******/ })()
;